import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SelectModule } from '@cmps/ng-select';
import {
    CmpsChipModule,
    CmpsIconModule,
    CmpsTooltipModule,
} from '@cmps/ng-uikit';

import { MainComponent } from './component/main/main.component';

@NgModule({
    declarations: [MainComponent],
    imports: [
        CmpsChipModule,
        CmpsIconModule,
        CmpsTooltipModule,
        CommonModule,
        SelectModule,
        FormsModule,
    ],
    exports: [MainComponent],
})
export class CmpsPopulationSelectModule {}
